export type Region = 'ru' | 'eu' | 'us';

const env = process.env.REACT_APP_REGION?.toLowerCase();
const validRegions: Region[] = ['ru', 'eu', 'us'];

export const REGION: Region = validRegions.includes(env as Region)
    ? (env as Region)
    : 'ru';
